module.exports = __webpack_public_path__ + "assets/img/CONNECTIVITY BROCHURE.bf50cf61.png";